import { useMemo } from 'react';
import { useParams } from 'react-router-dom';
import { ROLES } from '../consts/language';
import { useAuthContext } from '../context/AuthContext/AuthContext';

const usePermission = () => {
  const { userInfo } = useAuthContext();
  const { restaurantId: restaurantIdParam, astrolabStoreId } = useParams();

  const restaurantId: string = useMemo(() => {
    if (!userInfo) return '';
    if (userInfo?.role === ROLES.SUPER_ADMIN && astrolabStoreId) return astrolabStoreId || '';
    if (userInfo?.role === ROLES.SUPER_ADMIN && restaurantIdParam) return restaurantIdParam || '';
    if (userInfo?.role === ROLES.STAFF) return userInfo?.restaurant_id || '';
    return '';
  }, [userInfo, restaurantIdParam, astrolabStoreId]);

  const showForSuperAdmin = useMemo(() => {
    return userInfo?.role === ROLES.SUPER_ADMIN && !restaurantId;
  }, [userInfo?.role, restaurantId]);

  const showForAdmin = useMemo(() => {
    return userInfo?.role === ROLES.HEADQUARTER && !restaurantId;
  }, [userInfo?.role, restaurantId]);

  const isAstrolabStore = useMemo(() => {
    return userInfo?.role === ROLES.SUPER_ADMIN && astrolabStoreId;
  }, [astrolabStoreId, userInfo?.role]);

  const isAdminActionBlocked = useMemo(() => {
    return userInfo?.role === ROLES.SUPER_ADMIN && !!restaurantIdParam && !isAstrolabStore;
  }, [userInfo?.role, restaurantIdParam, isAstrolabStore]);

  return { restaurantId, showForSuperAdmin, showForAdmin, isAstrolabStore, isAdminActionBlocked };
};

export default usePermission;
